/* eslint-disable no-bitwise */
import type { Bitmap } from "./types.ts";
import { bitmapChannels } from "./types.ts";

/** @deprecated This is too slow. Anything iterating a bitmap shouldn't be using a callback per pixel */
function* iterateBitmapIndexGenerator(
	image: Bitmap,
	op: (index: number, x: number, y: number) => void,
	yieldSize: number,
) {
	if (yieldSize % bitmapChannels !== 0) {
		throw new Error(`yield size must be divisible by bitmapChannels`);
	}
	for (let y = 0; y < image.height; y++) {
		const indexBase = image.width * y;
		for (let x = 0; x < image.width; x++) {
			const idx = (indexBase + x) * bitmapChannels;
			op(idx, x, y);
			if (idx % yieldSize === 0) {
				yield;
			}
		}
	}
}

export { iterateBitmapIndexGenerator };
